import { render, staticRenderFns } from "./EventsDetail.vue?vue&type=template&id=16f854f4&"
import script from "./EventsDetail.vue?vue&type=script&lang=js&"
export * from "./EventsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports